import * as React from "react";
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { WithDefaultStyles, withDefaultStyles } from "utils/createStyles";
import { UserLevel } from "model/autogen/UserLevel";
import { IContentForm } from "./icontent-form";
import { QuoteModel } from "model/autogen/QuoteModel";
import { EditQuote } from "components/material/edit-quote";
import * as moment from "moment";
import { findPeopleHelper, resolvePeopleHelper, findTagsHelper, resolveTagsHelper } from "./form-state-helper";
import { PersonModel } from "model/autogen/PersonModel";
import { isArrayNullOrEmpty } from "utils/array";
import { FilesRequestFactory } from "model/autogen/FilesController";
import { TagModel } from "model/autogen/TagModel";
import { QuotedSubjectModel } from "model/autogen/QuotedSubjectModel";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { Spacer } from "components/utility-components";
import { Button, CircularProgress} from "@material-ui/core";
import Save from '@material-ui/icons/Save';
import { PeopleRequestFactory } from "model/autogen/PeopleController";
import { PeopleList } from "components/material/people-list";
import { PersonInfo } from "model/autogen/PersonInfo";
import AddCircle from "../../../node_modules/@material-ui/icons/AddCircle";
import { withEditorPage } from "pages/editor-page";
import { QuoteRequestFactory } from "model/autogen/QuoteController";

export interface INewQuoteProps extends IContentForm<QuoteModel> {

}

export interface IQuoteState {
    isSaving: boolean;
    isUploadingFiles: boolean;
    quote: QuoteModel;
    quoteAuthor: PersonInfo | undefined;
    shouldHaveValue: boolean;
    isEditing?: boolean | undefined
}

type NewQuoteFormComponentProps = INewQuoteProps & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles
class NewQuoteFormComponent extends React.Component<NewQuoteFormComponentProps, IQuoteState> {
    constructor(props: NewQuoteFormComponentProps) {
        super(props);
        this.state = {
            isSaving: false, isUploadingFiles: false, quote: {
                id: -1,
                topic: "",
                phrase: "",
                subjects: [],
                person: {} as PersonModel,
                assignFiles: [],
                files: [],
                dateOfQuote: new Date(),
                sourceURL: "",
                tags: [],
                createTags: [],
                type: 'Quotes',
                date: new Date(),
                title: "",
                author: ""
            }, 
            quoteAuthor: undefined,
            shouldHaveValue: false,
            isEditing: false,
        };
    }
    componentDidMount = () => {
        let { quote, quoteAuthor, shouldHaveValue, isEditing } = this.state
        isEditing = this.props.isEditing
        if (this.props.item) {
            shouldHaveValue = true
            quote = this.props.item
            quoteAuthor = { ...this.props.item.person };
            this.setState({quote, quoteAuthor, shouldHaveValue,})
        }
        this.setState({isEditing})
    }

    private onQuoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        var changedField = e.target.name
        var quote = this.state.quote
        quote[`${changedField}`] = e.target.value
        this.setState({ quote: quote })
    }
    private onDateChange = (date: moment.Moment) => {
        let { quote } = this.state
        quote.dateOfQuote = date.toDate();
        this.setState({ quote: quote });
    }
    private onFetchSubjects = (query: string) => {
        return findPeopleHelper(this.props.callApi, query)
    }
    private onResolveSubjects = (peopleIds: number[]) => {
        return resolvePeopleHelper(this.props.callApi, peopleIds);
    }

    private onSubjectsChanged = (people: PersonModel[]) => {
        if (people) {
            var { quote } = this.state;
            quote.subjects = people.map(p => {
                return {
                    id: -1,
                    subject: {
                        id: p.id,
                        firstName: p.firstName,
                        lastName: p.lastName
                    }
                } as QuotedSubjectModel;
            })

            this.setState({ quote });
        }
    }
    private onFileDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        const { callApi } = this.props;
        try {
            if (!isArrayNullOrEmpty(acceptedFiles)) {
                this.setState({ isUploadingFiles: true });
                const result = await callApi(f => FilesRequestFactory.upload(f, { file: acceptedFiles[0] }))
                const quote = this.state.quote;
                quote.assignFiles = [...(quote.assignFiles || []), result]
                this.setState({ isUploadingFiles: false, quote });
            }
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to upload file: ${e}`);
            this.setState({ isUploadingFiles: false });
        }
    }
    private onTagsChanged = (tags: TagModel[]) => {
        var quote = this.state.quote
        quote.createTags = tags
        this.setState({ quote: quote });
    }

    private onSearchTags = (query: string) => {
        return findTagsHelper(this.props.callApi, query, false);
    }

    private onResolveTags = (tags: string[]) => {
        return resolveTagsHelper(this.props.callApi, tags);
    }

    private onSave = async (e: any) => {
        const { quoteAuthor, quote } = this.state;
        const payload = quote
        const { callApi, showSnackbarMessage } = this.props;

        try {
            this.setState({ isSaving: true });
            const result = quoteAuthor != undefined ? await callApi((fetcher) => PeopleRequestFactory.addQuoteToPerson(fetcher, quoteAuthor.id, payload)) : null;
            if (this.props.user.level <= UserLevel.External) {
                showSnackbarMessage("Your content has been successfully submitted. It will be reviewed and posted by a Research Hub editor.Any questions, email researchhub@labour.org.nz");

            }
            else {
                result != null ? showSnackbarMessage(payload.id > 0 ? 'Transcript Saved' : `New Transcript saved (${result.documentId})`) : null;
            }
            this.props.onSaveCompleted();

        } catch (e) {
            showSnackbarMessage(`Error saving Transcript: ${(e.body || {}).message || "Error not specified"}`);
            this.setState({ isSaving: false });
        }
    }

    private newQuote = () => {
        let { quote, isSaving, quoteAuthor, shouldHaveValue, } = this.state
        quote.id = -1
        quote.topic = ""
        quote.phrase = ""
        quote.subjects = []
        quote.person = {} as PersonModel
        quote.assignFiles = []
        quote.files = []
        quote.dateOfQuote = new Date()
        quote.sourceURL = ""
        quote.tags = []
        quote.createTags = []
        quote.type = 'Quotes'
        quote.date = new Date()
        quote.title = ""
        quote.author = ""

        this.props.isEditing ? quoteAuthor : quoteAuthor = undefined
        isSaving = false;
        shouldHaveValue = false;
        this.setState({quote, quoteAuthor, isSaving, shouldHaveValue, })

    };

    private saveAndAddQuote = async (e: any) => {
        const { quoteAuthor, quote } = this.state;
        const payload = quote
        const { callApi, showSnackbarMessage } = this.props;

        try {
            this.setState({ isSaving: true });
            const result = quoteAuthor != undefined ? await callApi((fetcher) => PeopleRequestFactory.addQuoteToPerson(fetcher, quoteAuthor.id, payload)) : null;
            if (this.props.user.level <= UserLevel.External) {
                showSnackbarMessage("Your content has been successfully submitted. It will be reviewed and posted by a Research Hub editor.Any questions, email researchhub@labour.org.nz");
            }
            else {
                result != null ? showSnackbarMessage(payload.id > 0 ? 'Transcript Saved' : `New Transcript saved (${result.documentId})`) : null;
            }
            this.newQuote();

        } catch (e) {
            showSnackbarMessage(`Error saving Transcript: ${(e.body || {}).message || "Error not specified"}`);
            this.setState({ isSaving: false });
        }
    }

    private duplicateQuote = () => {
        let { quote, isSaving, shouldHaveValue } = this.state;
        let previousQuote = { ...quote };
        
        quote.id = -1
        quote.topic = previousQuote.topic
        quote.phrase = ""
        quote.subjects = previousQuote.subjects
        quote.person = previousQuote.person
        quote.assignFiles = []
        quote.files = previousQuote.files
        quote.dateOfQuote = previousQuote.dateOfQuote
        quote.sourceURL = previousQuote.sourceURL
        quote.createTags = previousQuote.createTags
        quote.type = 'Quotes'
        quote.date = new Date()
        quote.title = ""
        quote.author = ""
        if (previousQuote.createTags.length > 0) {
            quote.tags = previousQuote.createTags.map(ct => ct.name)
        } else {
            quote.tags = previousQuote.tags
        }
        
        isSaving = false;
        shouldHaveValue = true;
        this.setState({quote, isSaving, shouldHaveValue})
    }

    private saveAndDuplicateQuote = async (e: any) => {
        const { quoteAuthor, quote } = this.state;
        const payload = quote
        const { callApi, showSnackbarMessage } = this.props;

        try {
            this.setState({ isSaving: true });
            const result = quoteAuthor != undefined ? await callApi((fetcher) => PeopleRequestFactory.addQuoteToPerson(fetcher, quoteAuthor.id, payload)) : null;
            if (this.props.user.level <= UserLevel.External) {
                showSnackbarMessage("Your content has been successfully submitted. It will be reviewed and posted by a Research Hub editor.Any questions, email researchhub@labour.org.nz");
            }
            else {
                result != null ? showSnackbarMessage(payload.id > 0 ? 'Transcript Saved' : `New Transcript saved (${result.documentId})`) : null;
            }
            this.duplicateQuote();

        } catch (e) {
            showSnackbarMessage(`Error saving Transcript: ${(e.body || {}).message || "Error not specified"}`);
            this.setState({ isSaving: false });
        }
    }

    private onPersonSelected = (person: PersonInfo) => {
        let { quoteAuthor, shouldHaveValue } = this.state;
        quoteAuthor = person;
        shouldHaveValue = true;
        this.setState({ quoteAuthor, shouldHaveValue });
    }

    render() {

        const { isSaving, shouldHaveValue, quoteAuthor, quote } = this.state;
        // const { item } = this.props;
        let { isEditing } = this.props
        let cannotSaveQuote = false
        if (quote.id) {
            cannotSaveQuote = ((quote.assignFiles === null || quote.assignFiles.length === 0) && quote.sourceURL == "") || quote.phrase == "" || quoteAuthor == null
        } 
        const cannotSave = isSaving || cannotSaveQuote
        const authorName = quoteAuthor ? quoteAuthor.firstName + " " + quoteAuthor.lastName : ""

        return <>
            {isEditing && <h1>{authorName}</h1>}
            {!isEditing &&<PeopleList shouldHaveValue={shouldHaveValue} onPersonSelected={this.onPersonSelected} label={"Transcript Author"} {...this.props} />}
            <EditQuote editPage={true} quote={this.state.quote} onQuoteChange={this.onQuoteChange} onDateChange={this.onDateChange} onFetchSubjects={this.onFetchSubjects} onSubjectsChanged={this.onSubjectsChanged} onResolveSubjects={this.onResolveSubjects} onFileDrop={this.onFileDrop} isUploadingFiles={this.state.isUploadingFiles} onTagsChanged={this.onTagsChanged} onSearchTags={this.onSearchTags} onResolveTags={this.onResolveTags} key={this.state.quote.id} />
            <Spacer />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <Button disabled={isSaving || cannotSave} style={{ width: "35%" }} variant="extendedFab" onClick={this.saveAndAddQuote}><AddCircle />Additional Transcript </Button>
                <Button disabled={isSaving || cannotSave} style={{ width: "35%" }} variant="extendedFab" onClick={this.saveAndDuplicateQuote}><AddCircle />Duplicate Transcript </Button>
            </div>
            <Spacer />
            <Button variant="contained" fullWidth={true} onClick={this.onSave} disabled={isSaving || cannotSave} color="primary">
                {isSaving ? <CircularProgress size={24} /> : <Save />}{isSaving ? " Saving ..." : " Save"}
            </Button>
        </>
    }

}

// HACK: wrapper to workaround the fact that our current codegen doesn't support argument default values, so there's a signature mismatch
const newQuoteGet = (fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number) => QuoteRequestFactory.getById(fetcher, id, false);

const NewQuoteFormComponentWithDefaultStyles = withDefaultStyles(NewQuoteFormComponent);

export const NewQuoteForm = withSnackbar(withAuthContext(NewQuoteFormComponentWithDefaultStyles, UserLevel.Editor)) as React.ComponentType<INewQuoteProps>;

export const QuoteEditPage = withAuthContext(withEditorPage(NewQuoteForm as any, newQuoteGet), UserLevel.Editor) as React.ComponentType<INewQuoteProps>;



// WEBPACK FOOTER //
// ./src/components/forms/new-quote-form.tsx